module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan1-2-06e3b78d8fae7dbb31c8a629350ecb23.webp";